import _ from 'lodash';

import { getClosestThumbnailAsBackground } from 'shared/utils/thumbnails';

export const getImageStyle = ({
  image,
  thumbnails = [],
  width = 50,
  height = 50,
  color = 'grey',
  defaultImage = null,
  minHeight = 'unset',
  minWidth = 'unset',
  additionalStyles = {},
  backgroundSize = 'cover'
}) => {
  const backgroundImage = image || defaultImage;

  return !_.isNil(backgroundImage) || !_.isEmpty(thumbnails)
    ? {
        ...getClosestThumbnailAsBackground(thumbnails, width, height, {
          image: backgroundImage
        }),
        backgroundSize: backgroundSize,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: minHeight,
        minWidth: minWidth,
        ...additionalStyles
      }
    : { backgroundColor: color };
};

export const getAvatarStyle = (
  avatar,
  thumbnails,
  avatarPreview,
  width = 90,
  height = 90,
  defaultImage = null,
  additionalStyles = {},
  backgroundSize = 'cover'
) => {
  if (!_.isNil(avatarPreview)) {
    return {
      backgroundImage: `url(${avatarPreview})`,
      backgroundSize: backgroundSize,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      ...additionalStyles
    };
  }
  const darkBlue = '#30596e';

  return getImageStyle({
    image: avatar,
    thumbnails,
    width,
    height,
    color: darkBlue,
    defaultImage,
    backgroundSize,
    additionalStyles
  });
};
